import $http from '../../shared/http';
const selfRegistrationTokenKey = 'selfRegistrationToken';

export const membership_self_registrations = {
  namespaced: true,
  state: () => {
    return {
      isMembershipSelfRegistrationsExist: null,
      membershipSelfRegistrationData: null,
      selfRegistrationToken: null,
    };
  },
  getters: {
    getSelfRegistrationToken: (state, getters) => {
      return getters['tokenPayload']()?.token;
    },
    tokenPayload: () => () => {
      let tokenPayload = window.localStorage.getItem(selfRegistrationTokenKey);
      if (!tokenPayload) {
        return null;
      }
      tokenPayload = JSON.parse(tokenPayload);
      return tokenPayload;
    },
    getChurchName: (_, getters) => {
      return getters['tokenPayload']()?.churchName ?? '';
    },
    isLoggedInForSelfRegistration: (state, getters) => {
      return !!getters['getSelfRegistrationToken'];
    },
  },
  mutations: {
    setSelfRegistrationToken: (_, payload) => {
      // Directly persist to LocalStorage for a more reliable token persistence
      if (!payload) {
        window.localStorage.removeItem(selfRegistrationTokenKey);
        return;
      }
      window.localStorage.setItem(selfRegistrationTokenKey, JSON.stringify(payload));
    },

    clearSelfRegistrationToken() {
      window.localStorage.removeItem(selfRegistrationTokenKey);
    },
  },
  actions: {
    validateTokenPayload({ getters }, { churchId, hash }) {
      const tokenPayload = getters['tokenPayload']();
      if (!tokenPayload) {
        return false;
      }
      return (
        tokenPayload?.churchId === churchId && tokenPayload?.hash === hash && !!tokenPayload?.token
      );
    },

    async VERIFY_PASSCODE({ commit }, { passCode, hash, organisation_id }) {
      commit('setSelfRegistrationToken', null);

      return $http('v2')
        .post(
          `/membership_self_registrations/${organisation_id}/verify`,
          {
            pass_code: passCode,
            hash,
          },
          {
            redirectToLogin: false,
            notifiable: true,
          }
        )
        .then(async (response) => {
          commit('setSelfRegistrationToken', {
            token: response?.data?.data?.token ?? '',
            churchId: organisation_id,
            churchName: response?.data?.data?.churchName ?? '',
            hash,
          });

          return response.data;
        })
        .catch((error) => {
          return Promise.reject(error?.response ?? error);
        });
    },
  },
};
